// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JVkW-","content":"styles_content__3UzpQ","tableWrap":"styles_tableWrap__2hX0i"};